function errorDetail(body: string): string {
  try {
    const parsed = JSON.parse(body) as { error?: { message?: string } };
    return parsed.error?.message ?? body;
  } catch {
    return body;
  }
}

/** Throws with the backend's `{ error: { message } }` detail, if the response carries one. */
export async function assertOk(response: Response): Promise<void> {
  if (response.ok) {
    return;
  }
  const body = await response.text().catch(() => '');
  const status = `${response.status} ${response.statusText}`.trim();
  const detail = errorDetail(body);
  throw new Error(detail ? `${status}: ${detail}` : status);
}
